import React from 'react';
import moment from 'moment';
import { Connection, ConnectionSource, LedgerAccount } from '../types';
import { EllipsisText, Text } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';
import styled from 'styled-components';
import ErrorBanner from './ErrorBanner';
import getLedgerErrorMessage from './getLedgerErrorMessage';

const TableRow = styled.div`
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.silt};
  padding: 8px;
`;

type RowProps = {
  showOpeningBalance: boolean;
};

const Row = styled.div<RowProps>`
  align-items: center;
  display: grid;
  padding: 8px 0;
  grid-column-gap: 16px;
  grid-template-columns: ${({ showOpeningBalance }) =>
    showOpeningBalance ? '1fr 1fr 1fr' : '1fr 1fr'};
}
`;

type LedgerTableRowProps = {
  connection: Connection;
  ledger: LedgerAccount;
};

const LedgerTableRow = ({ connection, ledger }: LedgerTableRowProps) => {
  const showOpeningBalance =
    connection.source === ConnectionSource[ConnectionSource.STRIPE] ||
    connection.source === ConnectionSource[ConnectionSource.PAYPAL];
  const accountForLedger = connection.accounts.find(account => account.ledger?.id === ledger.id);

  const latestValidBalanceDate = accountForLedger?.ledger?.latestValidBalance?.map(
    balance => balance.date,
  )[0];
  const referenceBalanceDate = accountForLedger?.ledger?.referenceBalance?.map(
    balance => balance.date,
  )[0];

  const formatValidationPeriod = () => {
    if (!referenceBalanceDate) {
      return `N/A`;
    }

    return `${moment(referenceBalanceDate).format('MMM D, YYYY')} - ${
      latestValidBalanceDate ? moment(latestValidBalanceDate).format('MMM D, YYYY') : 'N/A'
    }`;
  };

  const formatStripeOpeningBalance = () => {
    const referenceBalance = accountForLedger?.ledger?.referenceBalance?.length
      ? accountForLedger?.ledger?.referenceBalance[0]
      : undefined;
    if (referenceBalance) {
      return `${referenceBalance.date} - $${
        referenceBalance.amount ? referenceBalance.amount / 100 : 0
      }`;
    }

    return 'N/A';
  };

  const ledgerErrorMessage = getLedgerErrorMessage(ledger, connection);

  return (
    <TableRow>
      <Row showOpeningBalance={showOpeningBalance}>
        <EllipsisText>
          <Text styleType="small" color={colors.cloud}>
            {ledger?.name}
          </Text>
        </EllipsisText>
        <Text styleType="small" color={colors.cloud}>
          {formatValidationPeriod()}
        </Text>
        {showOpeningBalance && (
          <Text styleType="small" color={colors.cloud}>
            {formatStripeOpeningBalance()}
          </Text>
        )}
      </Row>
      {ledgerErrorMessage && (
        <ErrorBanner>
          <p dangerouslySetInnerHTML={{ __html: ledgerErrorMessage }} />
        </ErrorBanner>
      )}
    </TableRow>
  );
};

export default LedgerTableRow;
